const KEY = 'sv_verification_role';

export type VerificationRole = 'editor' | 'approver';

export function readVerificationRole(): VerificationRole | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw === 'editor' || raw === 'approver') {
      return raw;
    }
    return null;
  } catch {
    return null;
  }
}

export function writeVerificationRole(role: VerificationRole): void {
  localStorage.setItem(KEY, role);
}
